import { render, staticRenderFns } from "./question-input.vue?vue&type=template&id=554ccaa0"
import script from "./question-input.vue?vue&type=script&lang=js"
export * from "./question-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports